































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { routingControlModule } from '../../store/modules/RoutingControl';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import router from '../../router';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationCheckResult extends ApiAccessBase {
  private title : string = '';
  private message : string = '';
    // 画面初期化処理
  // component生成時に実行
  private created() {
    const tmp = applicationFormModule.checkApplicationAccept.concat();
    if (tmp[0] === '1' ) {
      this.title = '申請受理完了';
      this.message = '申請書の受理が完了しました。';
    } else {
      this.title = '申請不受理完了';
      this.message = '以下の理由により申請書を不受理としました。\n不受理理由：' + tmp[1];
    }
  }

  /**
   * Topへ戻る
   */
  private backToTop() {
    this.deleteExclusive();
    router.push({name: UketsukeScreenName.UKETSUKE_ORDER_MAIN});
  }

  /**
   * 検索画面へ戻る
   */
  private backToSearch() {
    this.deleteExclusive();
    router.push({name: UketsukeScreenName.SEARCH_APPLICATION_TRADER});
  }

  /**
   * 排他ロック解除
   */
  private deleteExclusive() {
    this.apiAccess(UketsukeConstants.APP_TARDER_PATH + '/exclusive/delete/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.moduleResetDetail();
      }
    });
  }
}
